export default __webpack_public_path__ + "static/media/Lightbulb_2_filled.7093f622.svg";